import { render, staticRenderFns } from "./Tache.vue?vue&type=template&id=fe3c0a12&"
import script from "./Tache.vue?vue&type=script&lang=js&"
export * from "./Tache.vue?vue&type=script&lang=js&"
import style0 from "./Tache.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports